import { Box, Grid, Typography } from '@mui/material';
import ColorPicker from 'components/ColorPicker/ColorPicker';
import { Control, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';
import { SUBTITLE_MAX_LENGTH } from '../constants';
import WordCounterField from '../WordCounterField';

interface SubtitleSectionProps {
  control: Control<CreateGuiVersionType>;
  errors: FieldErrors<CreateGuiVersionType>;
  subtitleEnCount: number;
  subtitleHuCount: number;
  setSubtitleEnCount: (count: number) => void;
  setSubtitleHuCount: (count: number) => void;
  subtitleColor?: string;
  onSubtitleColorChange?: (color: string) => void;
}

export default function SubtitleSection({
  control,
  errors,
  subtitleEnCount,
  subtitleHuCount,
  setSubtitleEnCount,
  setSubtitleHuCount,
  subtitleColor = '',
  onSubtitleColorChange = () => {
    /* no-op */
  },
}: SubtitleSectionProps) {
  const { t } = useTranslation();

  return (
    <Grid item xs={12}>
      <Typography
        variant="subtitle1"
        sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}
      >
        {t('createGuiVersionPage.subtitle')}
        <ColorPicker value={subtitleColor} onChange={onSubtitleColorChange} />
      </Typography>

      <Box display="flex" gap={2} width="100%">
        <Box flex="1">
          <WordCounterField
            name="subtitleEn"
            control={control}
            errors={errors}
            label={t('createGuiVersionPage.subtitleEn')}
            maxLength={SUBTITLE_MAX_LENGTH}
            currentCount={subtitleEnCount}
            onCountChange={setSubtitleEnCount}
          />
        </Box>
        <Box flex="1">
          <WordCounterField
            name="subtitleHu"
            control={control}
            errors={errors}
            label={t('createGuiVersionPage.subtitleHu')}
            maxLength={SUBTITLE_MAX_LENGTH}
            currentCount={subtitleHuCount}
            onCountChange={setSubtitleHuCount}
          />
        </Box>
      </Box>
    </Grid>
  );
}
